import React, { useState, memo, useEffect, Fragment } from "react";

import { UnavailableAcceptanceResult } from './UnavailableAcceptanceResult';

export const UnavailableForm = (props) => {
  const { init_hospital, corporations } = props;

  return (
    <>
      <div className="accordion-item mt-5">
        <h2 className="accordion-header" id="panelsStayOpen-headingUnavailable">
          <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseUnavailable" aria-expanded="true" aria-controls="panelsStayOpen-collapseUnavailable">
            [実績]受入不可の一覧企業
          </button>
        </h2>
        <div id="panelsStayOpen-collapseUnavailable" className="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingUnavailable">
          <div className="accordion-body">
            <UnavailableAcceptanceResult init_hospital={init_hospital} corporations={corporations} />
          </div>
        </div>
      </div>
    </>
  );
};